import { validString } from 'src/app/shared/utilities/types.utils';
import { DEFAULT_LANGUAGE } from '../enums/default-configs.enums';

export const IS_IN_IFRAME = parent !== window;

/**
 * Returns the route params of the current url
 * @param window The window object
 */
export function getRouteParamsFromUrl(window: Window): string[] {
	const base: HTMLBaseElement | undefined = window.document.getElementsByTagName('base')[0];
	let pathname = window.location.pathname;

	if (base) {
		const baseHref = base.href;
		if (validString(baseHref)) {
			pathname = pathname.replace(baseHref, '');
		}
	}

	if (pathname.charAt(0) === '/') {
		pathname = pathname.slice(1);
	}

	if (pathname.charAt(pathname.length - 1) === '/') {
		pathname = pathname.slice(0, pathname.length - 1);
	}
	return pathname.split('/');
}

/**
 * Gets route params and replaces invalid lang with default lang
 * @param window Window Object
 * @param defaultLanguage override for default language
 */
export function routeToDefaultLang(window: Window, defaultLanguage?: string): void {
	const params = getRouteParamsFromUrl(window);
	params[2] = defaultLanguage ?? DEFAULT_LANGUAGE;

	window.location.href = `/${params.join('/')}`;
}
